export const SET_PROJECT_LIST = "SET_PROJECT_LIST";
export const SET_DEVICE_STATUS = "SET_DEVICE_STATUS";
export const SET_CURRENT_PROJECT_INFO = "SET_CURRENT_PROJECT_INFO";
export const SET_KEY_TEXT = "SET_KEY_TEXT";
